import { useEffect, useState } from "react";
import { repositoryMaster } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";

const SSOGetAccessKey = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>();

  const getData = async () => {
    setIsLoading(true);

    try {
      const res = await repositoryMaster.get<MessageResponse<any>>(
        "/api/v1/Auth/sso-get-access-key",
      );

      if (res && res.success) {
        const dataAPI = res.data;
        setData(dataAPI);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return <></>;
};

export default SSOGetAccessKey;
